const footer = {
  footer: {
    imageTitle: 'Visitez le site web Enphase Energy',
    privacy: 'Confidentialité',
    terms: 'Conditions',
    enphaseText: '©2008-%{currentYear} Enphase Energy Inc. Tous droits réservés.',
    language: 'Langue',
    production_ct: {
      verify_ct: "Vérifiez le CT",
      checlist_nodata: "Les données du compteur ne sont pas suffisantes pour effectuer ce contrôle",      
      production_meter_verification: "Vérification des compteurs de production",
      serial_no: "Numéro de série",
      polarity_check: "Vérification de la polarité",
      polarity_check_failed: "La vérification de la polarité a échoué",
      ct_missing_branch_check: "Vérification de l’absence de circuits de dérivation dans le CT",
      polarity_check_passed: "Vérification de la polarité réussie",
      ct_no_missing_branch_circuit: "Le CT ne manque pas de circuits de dérivation",
      incorrect_direction_or_phase_message: "Le sens ou la phase du CT de production pourrait être incorrect",
      hide_details: "Masquer les détails",
      check_try_again: "Vérifiez les points suivants et réessayez",
      pv_on_for_5_min: "Assurez-vous que le circuit PV est allumé et qu’il l’est depuis au moins 5 minutes",
      l1_wires_production_ct_message: "Vérifiez que seuls les fils L1 passent par le CT de production et que le flux de production est dans le sens de la flèche du CT, du PV au disjoncteur",
      blue_white_wires_position_message: "Assurez-vous que les fils bleus et blancs sont connectés aux bonnes positions dans le bornier Gateway",
      wires_include_pv_generation_not_load_storage: "Assurez-vous que les fils qui passent par le CT de production n’incluent que la production PV (pas de charge ni de stockage).",
      l1_a_correct_phase_message: "Assurez-vous que la phase correcte, c’est-à-dire L1(a), passe par le CT de production",
      l1_phase_consistency_check_message: "Vérifiez la cohérence de la phase L1 à l’aide d’un compteur numérique et assurez-vous que L1 des circuits PV et L1 de l’Gateway sont dans la même phase",
      missing_branch_warning: "Le CT de production peut avoir des circuits de dérivation manquants",
      test_only_valid_for_sunshine_hours: "Ce test n’est valable que pour les heures d’ensoleillement",
      reading_lower_than_expected: "Les relevés de production sont inférieurs aux prévisions. Vérifiez les points suivants, puis appuyez sur la touche et réessayez",
      wires_include_all_pv_generation: "Assurez-vous que le câble passant par le CT de production inclut tous les circuits de production PV",
      branch_circuit_reverse_check: "Assurez-vous qu’aucun des circuits de dérivation ne passe par le CT en sens inverse",
      storage_load_circuits_through_production_ct: "Assurez-vous que des circuits de stockage ou de charge passent par le CT de production",
      show_details: "Afficher les détails",
      verify_ct_not_supported_for_device: "Vérifier les TC n'est pas pris en charge par cet appareil",
      verify_ct_timeStamp: "Vérifié le",
      verify_ct_systemID: "identifiant du système",
      prodct_reversepolarity_text: "Le sens ou la phase du CT de production pourrait être incorrect",
      prodct_reverse_polarity_btn: "Inversion de polarité",
      verify_ct_timeout: "La demande a expiré. Veuillez réessayer"
    }
  }
};

export default footer;
